module.exports = __webpack_public_path__ + "static/review-9439fb1191d6cbe4f7873e0bdcdd2344.jpg";